export class Price {
    constructor({ invoice, items }) {
        this.invoice = invoice;
        this.items = items;
        this.number = Intl.NumberFormat(this.invoice.currency === "JPY" ? "ja-JP" : "id-ID", {
            style: "currency",
            currency: invoice.currency,
            maximumFractionDigits: 0,
        });
    }

    format(amount) {
        return Intl.NumberFormat(this.invoice.currency === "JPY" ? "ja-JP" : "id-ID", {
            style: "currency",
            currency: this.invoice.currency,
            maximumFractionDigits: 0,
        }).format(amount)
    }
s
    detail(price) {
        // convert currency
        if (price <= 0) return 0;
        let { currency, rate } = this.invoice;
        let amount = 0;

        if (currency === "JPY") {
            amount = price * rate;
        } else {
            amount = price / rate;
        }
        let detail = Intl.NumberFormat(currency === "JPY" ? "id-ID" : "ja-JP", {
            style: "currency",
            currency: currency === "JPY" ? "IDR" : "JPY",
            maximumFractionDigits: 0,
        }).format(amount);

        return detail
    }

    subtotal() {
        // subtotal items
        let subtotal = this.items.reduce((total, item) => {
            return total + item.price * item.qty;
        }, 0);
        let detail = this.detail(subtotal)
        
        return { subtotal: this.number.format(subtotal), detail, amount: subtotal};
    }

    total() {
        // grand total amount
        let { amount } = this.subtotal();
        let total = amount - this.invoice.deposit;
        let detail = this.detail(total);

        return { total: this.number.format(total), detail, };
    }
}
